import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {GSXInfo} from "../api";

export class GSXInfoService extends RestService<GSXInfo> {
    constructor(url: string) {
        url ? super(url) : super(REST_API_END_POINTS.GSX_INFO)
    }
}
